<template>
  <a :href="prakerjaDetailLink" class="no-underline">
    <BlCardMv
      :shadow="false"
      :class="!isHideBorder && 'border border-solid border-[#E0E0E0]'"
      class="prakerja-card flex flex-col h-full rounded"
    >
      <div class="relative">
        <BlProductImageAv
          :image-url="`${optimizeImageWidth(course.images[0].url, 320)}.webp`"
          :image-alt="courseName"
          is-lazy-load
          image-placeholder="https://s2.bukalapak.com/attachment/237412/placeholder.png"
          size="extra-large"
          object-fit="cover"
          class="prakerja-card__image w-full h-[98px] rounded-b-none"
        />
        <ComingSoon v-if="prakerjaRemainingStock === 0 && getPrakerjaComingSoonToggle" data-testid="coming-soon" variation="caption-10" />
      </div>

      <BlFlexContainerMv class="bg-white rounded-b" padding="8px" direction="column" justify-content="space-between">
        <BlCapsuleAv v-if="courseTypeWording" class="w-max ph-4 mb-8" variation="informational">{{ courseTypeWording }}</BlCapsuleAv>
        <BlTextAv :tag="titleTag" variation="caption-12" :ellipsis="3" class="prakerja-card__title leading-4 qa-card-name">
          {{ courseName }}
        </BlTextAv>

        <div>
          <BlTextAv variation="body-14" weight="bold" class="mt-8 qa-card-price">
            {{ course.discount.original_price | money }}
          </BlTextAv>

          <BlFlexContainerMv
            direction="row"
            align-items="center"
            class="mt-8 qa-rating-and-review"
            :class="!courseRating.value && 'invisible'"
          >
            <BlFlexItemAv v-if="courseRating.value" class="flex items-center justify-center space-x-[2px]">
              <IcoStar size="small" color="#FFA726" class="w-[12px] h-[12px]" />
              <BlTextAv color="secondary" variation="caption-10" class="qa-rating-value" style="font-size: 10px">
                {{ formatRatingValue }}
              </BlTextAv>
            </BlFlexItemAv>
            <div class="divider mr-4 ml-4"></div>
            <BlFlexItemAv v-if="courseRating.count" class="flex items-start justify-center">
              <BlTextAv color="secondary" variation="caption-10" class="qa-review-value">
                Diulas {{ course.rating.count | delimiter }}
              </BlTextAv>
            </BlFlexItemAv>
          </BlFlexContainerMv>
        </div>
      </BlFlexContainerMv>
    </BlCardMv>
  </a>
</template>

<script>
import {mapGetters} from 'vuex';
import {money, delimiter} from '@bukalapak/toolbox-helper/number-helper';
import {IcoStar} from '@bukalapak/bazaar-visual-next';
import {BlProductImageAv, BlCardMv, BlCapsuleAv} from '@bukalapak/bazaar-mweb-latest';
import {COURSE_TYPE} from '../../config/app';
import {generateURLString, encodeURI} from 'shared_js/coupon-deals';
import {optimizeImageWidth} from 'shared_js/image-helpers';
import ComingSoon from 'src/shared/components/ComingSoon';

export default {
  name: 'PrakerjaCard',
  filters: {money, delimiter},
  components: {IcoStar, BlProductImageAv, BlCardMv, BlCapsuleAv, ComingSoon},
  props: {
    course: {
      type: Object,
      required: true,
    },
    courseType: {
      type: String,
      default: '',
    },
    referrer: {
      type: String,
      default: null,
    },
    isHideBorder: {
      type: Boolean,
      default: false,
    },
    titleTag: {
      type: String,
      default: 'p',
    },
  },
  computed: {
    ...mapGetters('courses', ['getPrakerjaComingSoonToggle']),
    courseRating() {
      return {
        value: this.course.rating?.value ?? 0,
        count: this.course.rating?.count ?? 0,
      };
    },
    formatRatingValue() {
      return (Math.round(this.courseRating.value * 100) / 100).toFixed(1);
    },
    courseName() {
      const numberOfStar = (this.course.name.substr(0, 2).match(/\*/g) || []).length;
      return this.course.name.slice(numberOfStar);
    },
    prakerjaRemainingStock() {
      return this.course?.prakerja_remaining_stock;
    },
    prakerjaDetailLink() {
      let referrer;
      const referrerMapper = {
        search: `prakerja_search | ${this.$route.query.keyword}`,
        merchant: 'prakerja_merchant',
        'closest-course': 'prakerja_kelas_terdekat',
        'dynamic-section': this.$route.params.section_slug,
      };

      const predefinedReferrer = referrerMapper[this.$route.name];

      if (this.referrer) referrer = this.referrer;
      else if (predefinedReferrer) referrer = predefinedReferrer;

      const queryParams = {
        ...this.$route.query,
        referrer: referrer,
      };
      const url = generateURLString(`${this.courseName} ${this.course.id}`);
      return `${process.env.BASE_PATH}/${url}?${encodeURI(queryParams)}`;
    },
    courseTypeWording() {
      if (!this.courseType) return '';
      return COURSE_TYPE[this.courseType] || '';
    },
  },
  methods: {
    optimizeImageWidth,
  },
};
</script>

<style scoped>
.divider {
  height: 8px;
  width: 1px;
  background-color: #e8eaef;
}
</style>
